import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss'],
})
export class DefaultComponent implements OnInit {
  sideBarOpen = true;
  @ViewChild('sidenav') public sidenav: MatSidenav;
  constructor() {
 
  }

  ngOnInit(): void {
 
  }

  sideBarToggler(ev: any) {
   this.sidenav.toggle();
    // this.sideBarOpen = !this.sideBarOpen;
  }
}
